import React from 'react';
import PropTypes from 'prop-types';
import {
  DtpTable,
  DtpTableHeader,
} from 'dtp-react-components';
// import JsPDF from 'jspdf';
// import 'jspdf-autotable';
import { ExportToCsv } from 'export-to-csv';
import { estadosRequerimento } from '../../utils/constants';
import {
  Button,
} from '../../components/index';
// import base64image from '../../utils/base64image';

/* const exportarPdf = (props) => {
  const doc = new JsPDF({
    orientation: props.landscape ? 'landscape' : 'portrait',
  });
  const totalPagesExp = '{total_pages_count_string}';
  const head = [[' '].concat(props.headers)];
  const body = props.data.map((item, i) => [i + 1].concat(Object.values(item)));
  doc.autoTable({
    head,
    body,
    styles: { halign: 'center' },
    didDrawPage(data) {
      const diaAtual = new Date();
const diaAtualFormatado = `${diaAtual.getDate()}/${diaAtual.getMonth()}/${diaAtual.getFullYear()}`;
      doc.setFontSize(10);
      doc.setFontStyle('bold');
      // Header
      doc.addImage(base64image, 'PNG', data.settings.margin.left, 15, 10, 10);
  doc.text(`${props.legend} - Emitido em ${diaAtualFormatado}`, data.settings.margin.left + 15, 22);

      // Footer
      let str = `Página ${doc.internal.getNumberOfPages()}`;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = `${str} de ${totalPagesExp}`;
      }
      doc.setFontSize(10);

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      const { pageSize } = doc.internal;
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      doc.text(str, data.settings.margin.left, pageHeight - 10);
    },
    margin: { top: 30 },
  });

  // Total page number plugin only available in jspdf v1.0+
  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  doc.save('relatorio.pdf');
}; */

const exportarCsv = (props) => {
  let dadosRelatorio = null;
  if (props.exportacao && props.exportacao !== undefined && props.exportacao.length > 0) {
    dadosRelatorio = props.exportacao;
  } else {
    dadosRelatorio = props.data;
  }

  if (dadosRelatorio && dadosRelatorio !== undefined && dadosRelatorio.length > 0) {
    const csvExporter = new ExportToCsv({
      filename: 'relatorio',
      fieldSeparator: ';',
      showTitle: true,
      title: props.legend,
      showLabels: true,
      headers: props.headers.map(val => val.replace(' (*)', '')),
    });
    csvExporter.generateCsv(dadosRelatorio);
  }
};

// const decideTamanhoColuna = numeroCampos => 2000 / numeroCampos;

const atribuirHint = (props) => {
  let hint = '';
  if (props) {
    switch (props.estado) {
      case estadosRequerimento.INDEFERIDO:
        hint = 'Relatorio Analítico estado indeferido';
        break;
      case estadosRequerimento.ANALISE_SUSPENSA:
        hint = 'Relatorio Analítico estado análise suspensa';
        break;
      case estadosRequerimento.COMPENSADO:
        hint = 'Relatorio Analítico estado compensado';
        break;
      case estadosRequerimento.EM_EXIGENCIA:
        hint = 'Relatório Analítico estado em exigência';
        break;
      default:
        break;
    }
  }

  return hint;
};

const handleExigenciaCompleto = (props) => {
  props.exigenciasCompletoAction(props.rowAtual, 'analitico-especial-completo', props.estado);
};

const Relatorio = props => (
  <React.Fragment>
    {
      props.nomeRelatorio !== '' ? (
        <React.Fragment>
          {/* <Button
            hint="Exportar para PDF"
            onClick={() => { exportarPdf(props); }}
            icon="ico-doc-pdf"
            mini
          /> */}
          <Button
            hint="Exportar para CSV"
            onClick={() => { exportarCsv(props); }}
            icon="ico-doc-sheet"
            mini
          />
          {props.voltarAction ? (
            <Button
              hint="Voltar"
              icon="ico-arrow-curve-left"
              mini
              onClick={() => props.voltarAction()}
            />) : null
          }
          {props.paramExibirBotaoRelatorioAnalitico ? (
            <Button
              hint={atribuirHint(props)}
              icon="ico-clipboard-list"
              mini
              onClick={() => { handleExigenciaCompleto(props); }}
            />) : null
          }
          <div className="relatorio" style={{ '--relatorioWidth': props.containerStyle.width }}>
            <DtpTable {...props}>
              {props.headers.map((item, i) => (
                <DtpTableHeader
                  key={item}
                  dataField={props.data[0] ? Object.keys(props.data[0])[i] : 'default'}
                  dataAlign="center"
                  isKey={i === 0}
                  header={item}
                  tdStyle={{ wordBreak: 'break-word' }}
                  dataFormat={props.dataFormatOptions[i]}
                  hidden={props.options.hidden && props.options.hidden.includes(i)}
                />))}
            </DtpTable>
          </div>
        </React.Fragment>
    ) : null}
  </React.Fragment>
);

Relatorio.propTypes = {
  dataFormatOptions: PropTypes.objectfunc,
  voltarAction: PropTypes.func,
  exigenciasCompletoAction: PropTypes.func,
}.isRequired;

Relatorio.defaultProps = {
  voltarAction: () => null,
};

export default Relatorio;



// WEBPACK FOOTER //
// ./src/pages/relatorios/Relatorio.jsx